// regex matches in process entity names << miru.notfinished.yet
export const incompleteEntityRegex = /<<([^>]*)$/;

// regex that matches urls
export const urlRegex =
  /^https?:\/\/(www\.)?[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]+$/;

// Improved regex for email validation (RFC 5322 Official Standard, simplified)
// Source: https://emailregex.com/ (see site for caveats)
export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

// matches  entities that are complete << miru.finished.complete >>
const entityReplacementPlaceholder = "<<\\s*([^<>]*)\\s*>>";

// matches liquid replacements for entities that are complete << miru.finished.complete >>
const liquidTemplateReplacementPlaceholder = "{{\\s*([^{}]*)\\s*}}";

// regex to determine if there are liquid templates elements present
export const containsLiquidTemplateRegex =
  /({{[\s\S]*?}}|{%-?[\s\S]*?-?%}|<<[\s\S]*?>>)/g;

export const entityPlaceholderRegex = new RegExp(
  entityReplacementPlaceholder,
  "g",
);

export const liquidTemplatePlaceholderRegex = new RegExp(
  liquidTemplateReplacementPlaceholder,
  "g",
);

export const validEntityName = /^entity(?:\.[a-z0-9_-]+){1,4}$/;

export const runtimeTypes = ["string", "number", "date"];

export const runtimePlaceholderRegex =
  /^runtime\.(string|number|date)\.[\w-]+$/i;

// IP address pattern for highlighting
export const ipPattern = "\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}";

// Node link pattern for converting node:// links to anchor links
export const nodeLinkRegex = /\[([^\]]+)\]\(node:\/\/([^)]+)\)/g;
